import auth from './auth';
import user from './user';
import schools from './schools';
import vacancies from './vacancies';
import mapbox from './mapbox';
import applications from './applications';
import candidates from './candidates';
import teachersAuth from './teachersAuth';

export default {
  auth,
  user,
  schools,
  vacancies,
  mapbox,
  applications,
  candidates,
  teachersAuth,
};
